import { Component } from '@angular/core';

import { IWeissmanModalComponent } from '../../Compliance/WeissmanModalService';
import { ModalWrapperComponent } from '../../UI-Lib/Modal-Wrapper/modalWrapper.component';
import { BsModalRef } from 'ngx-bootstrap/modal';

export interface PicklistModalComponentParams {
    picklist: any[];
}

@Component({
    selector: 'picklist-modal',
    templateUrl: './picklistModal.component.html',
    imports: [ModalWrapperComponent],
})
export class PicklistModalComponent implements IWeissmanModalComponent<PicklistModalComponentParams, void> {
    constructor(private readonly _bsModalRef: BsModalRef) {}
    params: PicklistModalComponentParams;
    result: void;

    cancel(): void {
        this._bsModalRef.hide();
    }
}
